// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatorCard {
  padding: 0;
}
.CreatorCard .CreatorCard-highlight {
  display: grid;
  padding: 0 70px;
  grid-template-columns: 2fr 3fr;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left {
  display: flex;
  flex-direction: column;
  min-height: 450px;
  flex: 1 1;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left > p {
  margin-top: 16px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-first-column-checkbox {
  display: none !important;
  left: 0;
  top: 4px;
  position: absolute;
  z-index: 1;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left div.CreatorCard-first-column-checkbox[class*=dist_checked] {
  display: flex !important;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-highlight-left-h3 {
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  color: var(--color_primary_500);
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-body-text {
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 600;
  line-height: 18px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-second-column {
  padding: 0;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-highlight-charts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 32px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-highlight-charts p {
  margin-bottom: 16px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-left .CreatorCard-highlight-charts .CreatorCard-highlight-charts-views {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right {
  display: flex;
  margin-left: 100px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-first-column-checkbox {
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 0;
  display: none !important;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right div.CreatorCard-first-column-checkbox[class*=dist_checked] {
  display: flex !important;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video {
  cursor: pointer;
  position: relative;
  width: 100%;
  max-height: 450px;
  overflow: visible;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video .LivePostTag {
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 12px;
  color: var(--base_color1);
  line-height: 20px;
  font-size: 14px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video p.caption {
  margin: 0;
  font-size: 12px;
  color: var(--gray_dark1);
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video .thumbnail-component-container {
  overflow: hidden;
  border-radius: 8px;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video .thumbnail-component-container img {
  display: block;
  object-fit: cover;
  height: 305px;
  transition: all 0.5s ease;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video .thumbnail-component-container img:hover {
  filter: brightness(80%);
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video .checkbox {
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 8px;
  display: none;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video div.checkbox[class*=dist_checked] {
  display: flex;
}
.CreatorCard .CreatorCard-highlight .CreatorCard-highlight-right .CreatorCard-highlight-right-video:hover .checkbox {
  display: flex;
}
.CreatorCard .CreatorCard-first-column-checkbox {
  display: none !important;
  left: 0;
  position: absolute;
  z-index: 1;
  top: 4px;
}
.CreatorCard div.CreatorCard-first-column-checkbox[class*=dist_checked] {
  display: flex !important;
}
.CreatorCard:hover .CreatorCard-first-column-checkbox,
.CreatorCard:hover .CreatorCard-highlight-left,
.CreatorCard:hover .CreatorCard-highlight-right,
.CreatorCard:hover .CreatorCard-highlight-left .CreatorCard-first-column-checkbox,
.CreatorCard:hover .CreatorCard-highlight-right .CreatorCard-first-column-checkbox {
  display: flex !important;
}
.CreatorCard:hover .CreatorCard-second-column .brand-flag {
  display: flex;
}
.CreatorCard:hover .CreatorCard-first-column .select-tag {
  display: flex;
}
.CreatorCard.selected .CreatorCard-first-column .select-tag {
  display: flex;
}
.CreatorCard .CreatorCard-inside-container {
  display: flex;
  min-height: 117px;
  max-height: 117px;
}
.CreatorCard .CreatorCard-first-column {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.CreatorCard .CreatorCard-first-column .select-tag {
  border: 1px solid var(--gray);
  color: var(--gray);
  display: none;
  font-size: 12px;
  margin: 8px 0 0 1px;
  padding: 4px 13px;
  border-radius: 999em;
  font-weight: 600;
}
.CreatorCard .CreatorCard-first-column .thumbnail-container.highlight {
  width: 100px;
  height: 100px;
}
.CreatorCard .CreatorCard-first-column .thumbnail-container {
  position: relative;
  height: 84px;
  width: 84px;
}
.CreatorCard .thumbnail-container > a > div > svg,
.CreatorCard .thumbnail-container > a > div > img {
  border-radius: 100%;
  border: 1px solid var(--gray_light2);
}
.CreatorCard .CreatorCard-second-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 20px;
}
.CreatorCard .CreatorCard-second-column .title {
  font-size: 14px;
  line-height: 20px;
  color: var(--base_color1);
  margin-top: 1px;
  min-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-word;
  max-width: 190px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-brand-country-container {
  display: flex;
  font-size: 12px;
  line-height: 15px;
  color: var(--gray_dark1);
}
.CreatorCard .CreatorCard-second-column .CreatorCard-brand-country-container .CreatorCard-brand {
  color: var(--color_primary_500);
}
.CreatorCard .CreatorCard-second-column .CreatorCard-brand-country-container .CreatorCard-brand-country-separator {
  padding: 0 3px;
}
.CreatorCard .CreatorCard-second-column .TopicListSmall {
  padding-top: 8px;
  flex: 1 1;
}
.CreatorCard .CreatorCard-second-column .TopicListSmall h6 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 150px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content {
  padding-top: 24px;
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  line-height: 15px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-subscribers,
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CardMetricVariation {
  padding-right: 22px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-small-title {
  color: var(--base_color1);
  text-transform: capitalize;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-subtitle {
  color: var(--gray);
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier {
  position: relative;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover {
  position: absolute;
  display: flex;
  display: none;
  flex-direction: column;
  top: -8px;
  left: calc(100% + 16px);
  z-index: 2;
  box-shadow: var(--shadow_popup);
  height: -webkit-max-content;
  height: -moz-max-content;
  height: max-content;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 16px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover h5 {
  color: var(--base_color1);
  margin-bottom: 16px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover .tier-details-group {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover .tier-details-group > h6 {
  max-width: 110px;
  margin-left: 17px;
  font-size: 14px;
  color: var(--gray_dark2);
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover .tier-details-group > h6:first-child {
  color: var(--base_color1);
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover .tier-details-group > h6:nth-child(2) {
  text-transform: none;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover .tier-details-group > img {
  width: 50px;
  height: 44px;
  margin-right: 20px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-details-popover .tier-observation {
  font-size: 12px;
  color: var(--gray_light1);
  max-width: 210px;
  margin-top: 16px;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier:hover .tier-details-popover {
  display: flex;
}
.CreatorCard .CreatorCard-second-column .CreatorCard-subscribers-content .CreatorCard-tier .tier-tag {
  background-color: var(--color_primary_500);
  color: var(--base_color2);
  border-radius: 9999px;
  padding: 5px 15px;
  font-size: 14px;
  font-weight: normal;
}
.CreatorCard .CreatorCard-Follow {
  margin: 14px 0 0;
}
.CreatorCard .CreatorCard-seeVideos-btn {
  margin-left: 0;
  max-width: 316px;
  width: 100%;
  display: block;
  text-align: center;
  font-weight: var(--bold_weight);
}`, "",{"version":3,"sources":["webpack://./src/components/CreatorCard/index.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;AACN;AACM;EACE,gBAAA;AACR;AAEM;EACE,wBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;AAAR;AAGM;EACE,wBAAA;AADR;AAIM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAFR;AAKM;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AAHR;AAMM;EACE,UAAA;AAJR;AAOM;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;AALR;AAOQ;EACE,mBAAA;AALV;AAQQ;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AANV;AAWI;EACE,aAAA;EACA,kBAAA;AATN;AAWM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,wBAAA;AATR;AAYM;EACE,wBAAA;AAVR;AAaM;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AAXR;AAaQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAXV;AAcQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAbV;AAeU;EACE,SAAA;EACA,eAAA;EACA,wBAAA;AAbZ;AAiBQ;EACE,gBAAA;EACA,kBAAA;AAfV;AAiBU;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AAfZ;AAiBY;EACE,uBAAA;AAfd;AAoBQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AAlBV;AAqBQ;EACE,aAAA;AAnBV;AAuBU;EACE,aAAA;AArBZ;AA4BE;EACE,wBAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AA1BJ;AA6BE;EACE,wBAAA;AA3BJ;AAgCI;;;;;EAKE,wBAAA;AA9BN;AAiCI;EACE,aAAA;AA/BN;AAmCM;EACE,aAAA;AAjCR;AAwCM;EACE,aAAA;AAtCR;AA2CE;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;AAzCJ;AA4CE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA1CJ;AA4CI;EACE,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AA1CN;AA6CI;EACE,YAAA;EACA,aAAA;AA3CN;AA8CI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AA5CN;AAgDE;;EAEE,mBAAA;EACA,oCAAA;AA9CJ;AAiDE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA/CN;AAkDI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AAhDN;AAkDM;EACE,+BAAA;AAhDR;AAmDM;EACE,cAAA;AAjDR;AAqDI;EACE,gBAAA;EACA,SAAA;AAnDN;AAqDM;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAnDR;AAuDI;EACE,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AArDN;AAuDM;;EAEE,mBAAA;AArDR;AAwDM;EACE,yBAAA;EACA,0BAAA;AAtDR;AAyDM;EACE,kBAAA;AAvDR;AA0DM;EACE,kBAAA;AAxDR;AA0DQ;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,+BAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,aAAA;AAxDV;AA0DU;EACE,yBAAA;EACA,mBAAA;AAxDZ;AA2DU;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAzDZ;AA2DY;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AAzDd;AA2Dc;EACE,yBAAA;AAzDhB;AA4Dc;EACE,oBAAA;AA1DhB;AA8DY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA5Dd;AAgEU;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AA9DZ;AAmEU;EACE,aAAA;AAjEZ;AAqEQ;EACE,0CAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAnEV;AAyEE;EACE,gBAAA;AAvEJ;AA0EE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;AAxEJ","sourcesContent":[".CreatorCard {\n  padding: 0;\n\n  .CreatorCard-highlight {\n    display: grid;\n    padding: 0 70px;\n    grid-template-columns: 2fr 3fr;\n\n    .CreatorCard-highlight-left {\n      display: flex;\n      flex-direction: column;\n      min-height: 450px;\n      flex: 1;\n\n      >p {\n        margin-top: 16px;\n      }\n\n      .CreatorCard-first-column-checkbox {\n        display: none !important;\n        left: 0;\n        top: 4px;\n        position: absolute;\n        z-index: 1;\n      }\n\n      div.CreatorCard-first-column-checkbox[class*='dist_checked'] {\n        display: flex !important;\n      }\n\n      .CreatorCard-highlight-left-h3 {\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 30px;\n        color: var(--color_primary_500);\n      }\n\n      .CreatorCard-body-text {\n        font-size: 14px;\n        text-transform: capitalize;\n        font-weight: 600;\n        line-height: 18px;\n      }\n\n      .CreatorCard-second-column {\n        padding: 0;\n      }\n\n      .CreatorCard-highlight-charts {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        margin-top: 32px;\n\n        p {\n          margin-bottom: 16px;\n        }\n\n        .CreatorCard-highlight-charts-views {\n          position: relative;\n          display: flex;\n          flex-direction: column;\n          justify-content: flex-end;\n        }\n      }\n    }\n\n    .CreatorCard-highlight-right {\n      display: flex;\n      margin-left: 100px;\n\n      .CreatorCard-first-column-checkbox {\n        position: absolute;\n        z-index: 1;\n        top: 4px;\n        left: 0;\n        display: none !important;\n      }\n\n      div.CreatorCard-first-column-checkbox[class*='dist_checked'] {\n        display: flex !important;\n      }\n\n      .CreatorCard-highlight-right-video {\n        cursor: pointer;\n        position: relative;\n        width: 100%;\n        max-height: 450px;\n        overflow: visible;\n\n        .LivePostTag {\n          position: absolute;\n          z-index: 1;\n          top: 8px;\n          right: 8px;\n        }\n\n        p {\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n\n          margin-top: 12px;\n          color: var(--base_color1);\n          line-height: 20px;\n          font-size: 14px;\n\n          &.caption {\n            margin: 0;\n            font-size: 12px;\n            color: var(--gray_dark1);\n          }\n        }\n\n        .thumbnail-component-container {\n          overflow: hidden;\n          border-radius: 8px;\n\n          img {\n            display: block;\n            object-fit: cover;\n            height: 305px;\n            transition: all 0.5s ease;\n\n            &:hover {\n              filter: brightness(80%);\n            }\n          }\n        }\n\n        .checkbox {\n          position: absolute;\n          z-index: 1;\n          top: 8px;\n          left: 8px;\n          display: none;\n        }\n\n        div.checkbox[class*='dist_checked'] {\n          display: flex;\n        }\n\n        &:hover {\n          .checkbox {\n            display: flex;\n          }\n        }\n      }\n    }\n  }\n\n  .CreatorCard-first-column-checkbox {\n    display: none !important;\n    left: 0;\n    position: absolute;\n    z-index: 1;\n    top: 4px;\n  }\n\n  div.CreatorCard-first-column-checkbox[class*='dist_checked'] {\n    display: flex !important;\n  }\n\n  &:hover {\n\n    .CreatorCard-first-column-checkbox,\n    .CreatorCard-highlight-left,\n    .CreatorCard-highlight-right,\n    .CreatorCard-highlight-left .CreatorCard-first-column-checkbox,\n    .CreatorCard-highlight-right .CreatorCard-first-column-checkbox {\n      display: flex !important;\n    }\n\n    .CreatorCard-second-column .brand-flag {\n      display: flex;\n    }\n\n    .CreatorCard-first-column {\n      .select-tag {\n        display: flex;\n      }\n    }\n  }\n\n  &.selected {\n    .CreatorCard-first-column {\n      .select-tag {\n        display: flex;\n      }\n    }\n  }\n\n  .CreatorCard-inside-container {\n    display: flex;\n    min-height: 117px;\n    max-height: 117px;\n  }\n\n  .CreatorCard-first-column {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n\n    .select-tag {\n      border: 1px solid var(--gray);\n      color: var(--gray);\n      display: none;\n      font-size: 12px;\n      margin: 8px 0 0 1px;\n      padding: 4px 13px;\n      border-radius: 999em;\n      font-weight: 600;\n    }\n\n    .thumbnail-container.highlight {\n      width: 100px;\n      height: 100px;\n    }\n\n    .thumbnail-container {\n      position: relative;\n      height: 84px;\n      width: 84px;\n    }\n  }\n\n  .thumbnail-container>a>div>svg,\n  .thumbnail-container>a>div>img {\n    border-radius: 100%;\n    border: 1px solid var(--gray_light2);\n  }\n\n  .CreatorCard-second-column {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding-left: 20px;\n\n    .title {\n      font-size: 14px;\n      line-height: 20px;\n      color: var(--base_color1);\n      margin-top: 1px;\n      min-height: 20px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      word-break: break-word;\n      max-width: 190px;\n    }\n\n    .CreatorCard-brand-country-container {\n      display: flex;\n      font-size: 12px;\n      line-height: 15px;\n      color: var(--gray_dark1);\n\n      & .CreatorCard-brand {\n        color: var(--color_primary_500);\n      }\n\n      & .CreatorCard-brand-country-separator {\n        padding: 0 3px;\n      }\n    }\n\n    .TopicListSmall {\n      padding-top: 8px;\n      flex: 1;\n\n      h6 {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        max-width: 150px;\n      }\n    }\n\n    .CreatorCard-subscribers-content {\n      padding-top: 24px;\n      display: flex;\n      justify-content: flex-start;\n      font-size: 12px;\n      line-height: 15px;\n\n      & .CreatorCard-subscribers,\n      .CardMetricVariation {\n        padding-right: 22px;\n      }\n\n      .CreatorCard-small-title {\n        color: var(--base_color1);\n        text-transform: capitalize;\n      }\n\n      .CreatorCard-subtitle {\n        color: var(--gray);\n      }\n\n      .CreatorCard-tier {\n        position: relative;\n\n        .tier-details-popover {\n          position: absolute;\n          display: flex;\n          display: none;\n          flex-direction: column;\n          top: -8px;\n          left: calc(100% + 16px);\n          z-index: 2;\n          box-shadow: var(--shadow_popup);\n          height: max-content;\n          width: max-content;\n          padding: 16px;\n\n          h5 {\n            color: var(--base_color1);\n            margin-bottom: 16px;\n          }\n\n          .tier-details-group {\n            display: flex;\n            align-items: center;\n            flex-grow: 1;\n\n            &>h6 {\n              max-width: 110px;\n              margin-left: 17px;\n              font-size: 14px;\n              color: var(--gray_dark2);\n\n              &:first-child {\n                color: var(--base_color1);\n              }\n\n              &:nth-child(2) {\n                text-transform: none;\n              }\n            }\n\n            &>img {\n              width: 50px;\n              height: 44px;\n              margin-right: 20px;\n            }\n          }\n\n          .tier-observation {\n            font-size: 12px;\n            color: var(--gray_light1);\n            max-width: 210px;\n            margin-top: 16px;\n          }\n        }\n\n        &:hover {\n          .tier-details-popover {\n            display: flex;\n          }\n        }\n\n        .tier-tag {\n          background-color: var(--color_primary_500);\n          color: var(--base_color2);\n          border-radius: 9999px;\n          padding: 5px 15px;\n          font-size: 14px;\n          font-weight: normal;\n        }\n      }\n    }\n  }\n\n  .CreatorCard-Follow {\n    margin: 14px 0 0;\n  }\n\n  .CreatorCard-seeVideos-btn {\n    margin-left: 0;\n    max-width: 316px;\n    width: 100%;\n    display: block;\n    text-align: center;\n    font-weight: var(--bold_weight);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
